document.addEventListener("DOMContentLoaded", function() {
    var closeButton = document.querySelector('.app-banner__close');
    var elementToHide = document.querySelector('.app-banner');

    if (closeButton && elementToHide) {
        closeButton.addEventListener('click', function() {
            elementToHide.style.display = 'none';
        });
    }
  var popupButton = document.querySelector('.app-pop-up__close');
    var popupToHide = document.querySelector('.app-pop-up');

    if (popupButton && popupToHide) {
        popupButton.addEventListener('click', function() {
            popupToHide.style.display = 'none';
        });
    }
});